import { Component, Input } from '@angular/core';
import { UntypedFormControl, FormGroupDirective } from '@angular/forms';

import { ReviewChecklistItemEnum } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    selector: 'et-review-report-checklist-item',
    templateUrl: './review-report-checklist-item.component.html',
    standalone: false
})
export class ReviewReportChecklistItemComponent {

    public readonly reviewChecklistItemEnum = ReviewChecklistItemEnum;

    @Input()
    public itemControlName: string;

    @Input()
    public index: number;

    @Input()
    public label: string;

    @Input()
    public triState: boolean;

    @Input()
    public showDivider = true;

    public get control(): UntypedFormControl {
        return this._parentFormGroup.form.get(this.itemControlName) as UntypedFormControl;
    }

    constructor(private readonly _parentFormGroup: FormGroupDirective) {
    }
}
